import { isEqual, isObject } from 'lodash';

export const checkIfNeedToGenerate = (value: unknown, initial: unknown) => {
  const isEmptyValue = !value;
  const isEqualInitialPrimitive = value === initial;
  const isEqualInitialObject = isObject(value) && isEqual(value, initial);
  const isEqualInitialArray = Array.isArray(value) && (value.length === 0 || isEqual(value, initial));

  return isEmptyValue || isEqualInitialPrimitive || isEqualInitialObject || isEqualInitialArray;
};
